import * as Sentry from '@sentry/vue'

const VEHICLE_STORAGE_KEY = 'linked_vehicle'

function loadStoredVehicle() {
  try {
    return JSON.parse(localStorage.getItem(VEHICLE_STORAGE_KEY)) || null
  } catch {
    return null
  }
}

const appStore = {
  state: {
    pageTitle: '',
    user: {},
    vehicle: loadStoredVehicle(),
  },
  getters: {
    'appGetPageTitle': state => {
      return state.pageTitle
    },

    'user': state => {
      return state.user
    },

    'vehicle': state => {
      return state.vehicle
    },
  },
  mutations: {
    'app.setPageTitle': (state, payload) => {
      state.pageTitle = payload
    },

    'app.setUser': (state, payload) => {
      state.user = payload

      Sentry.setUser({
        id: payload.id,
        username: payload.name,
        email: payload.email,
      })
    },

    'app.setVehicle': (state, payload) => {
      state.vehicle = payload

      if (payload) {
        localStorage.setItem(VEHICLE_STORAGE_KEY, JSON.stringify(payload))
      } else {
        localStorage.removeItem(VEHICLE_STORAGE_KEY)
      }
    },
  },
  actions: { },
}

export default appStore
